import { render, staticRenderFns } from "./ai-chat-widget.vue?vue&type=template&id=06980a54&scoped=true"
import script from "./ai-chat-widget.vue?vue&type=script&lang=js"
export * from "./ai-chat-widget.vue?vue&type=script&lang=js"
import style0 from "./ai-chat-widget.vue?vue&type=style&index=0&id=06980a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06980a54",
  null
  
)

export default component.exports